import GlassContainer from "@/shared/components/glasscontainer";
import icon from "@/assets/icons/settings_icon.svg";

interface UserSettingsSidebarProps {
  totalSettings: number;
  loading: boolean;
}

export function UserSettingsSidebar({
  totalSettings,
  loading,
}: UserSettingsSidebarProps) {
  return (
    <aside className="w-80 shrink-0 px-8 pb-20 flex flex-col items-center justify-center overflow-y-auto min-h-screen">
      <img src={icon} className="size-68" />
      <h1 className="text-2xl font-bold tracking-tight text-foreground mb-3 text-center">
        Configuración del sistema
      </h1>
      <p className="text-sm text-foreground/50 leading-relaxed text-center">
        Administra las claves de configuración del sistema. Los valores secretos
        se muestran enmascarados por seguridad.
      </p>
      <div className="mt-8 space-y-3 w-full">
        <GlassContainer className="flex items-center justify-center gap-x-5 p-4">
          <p className="text-xs font-semibold text-foreground/60 uppercase tracking-widest mb-1">
            Total de claves
          </p>
          <p className="text-3xl font-bold text-foreground">
            {loading ? "—" : totalSettings}
          </p>
        </GlassContainer>
      </div>
    </aside>
  );
}
